module.exports = __webpack_public_path__ + "images/travel.edbe9f0be5852482ce8e1e01f22f1974.svg";